import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { SupportDataForm } from '../_models/support-data-form';
import { SupportService } from '../_services/support.service';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../_services/auth.service';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';

@Component({
  selector: 'app-patent-filing-process',
  templateUrl: './patent-filing-process.component.html',
  styleUrls: ['./patent-filing-process.component.css']
})
export class PatentFilingProcessComponent implements OnInit {
  supportDataForm: SupportDataForm = new SupportDataForm();
  userDataSession
  userDetailsId = 0;
 

  constructor(
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private supportService: SupportService,
    private snotifyService: SnotifyService,
  ) { }

  ngOnInit() {
    this.authService.checkUserSession();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
    }
  }

  // filingSupport(processDetails: any): void {
  //   // if (supportDetails.description) {
  //   //   this.spinnerService.show();
  //   //   this.supportDataForm.userDetailsId = this.userDetailsId;
  //   //   this.supportDataForm.enquiryMessage = supportDetails.description;
  //   //   this.supportDataForm.imageUrl = supportDetails.screenshot;
  //   //   this.supportDataForm.currentPageUrl = window.location.href;
  //   //   this.supportService.saveSupportDetails(this.supportDataForm).subscribe(
  //   //     resp => {
  //   //       this.spinnerService.hide();
  //   //       this.snotifyService.success("Your enquiry has been submitted successfully");
  //   //     },
  //   //     error => {
  //   //       this.spinnerService.hide();
  //   //       console.log(error);
  //   //     })
  //   // }
  //   console.log(processDetails);
  // }
}
